export enum OrderConditions {
  AscendingSort = "AscendingSort",
  DescendingSort = "DescendingSort",
  Favorites= "Favorites",
}
